import normalizeOption from "./normalizeOption";

export default function normalizeOptions(options, { emptyOption } = {}) {
  if (!options && !emptyOption) {
    return [];
  }
  options = options || [];
  if (emptyOption) {
    if (typeof emptyOption !== "object") {
      emptyOption = {
        label: emptyOption,
      };
    }
    emptyOption = { value: "", ...emptyOption };
  }
  if (!Array.isArray(options)) {
    return Object.entries(options).map(([value, rest]) => ({
      ...normalizeOption(rest),
      value,
    }));
  }
  options = options.map(normalizeOption);
  return emptyOption ? [emptyOption, ...options] : options;
}
